import { Line } from 'vue-chartjs';
import 'chartjs-plugin-labels';

export default{
    extends: Line,

    data(){
        return {
            // tName: 'nha label li',
        }
    },

    //props: [ 'gBorderColor', 'gColor', 'gLabel', 'gLabels', 'gRows', 'gDataSet'],

    props:{
        gDataSet:{
            type: String,
            // default: [],
        },
        gLabels:{
            type: String
        }
    },


    mounted(){
        let options = {
            // All of my other bar chart option here
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero:true
                    }
                }]
            },
            responsive: true, maintainAspectRatio: false,

        };

         this.renderChart({
             labels: JSON.parse(this.gLabels),

             datasets: JSON.parse(this.gDataSet),
             // datasets: [
                 // {label: this.gLabel, borderColor: this.gColor, backgroundColor: this.gBorderColor, data: this.gRows},
             // ]
         }, options)
    }
}